// Site-specific colors used outside the MUI theme's own palette (which AppTheme.js
// doesn't customize — see AppTheme.js). 

export const COLORS = {
    darkSection: '#14223f',
    overlay: 'rgba(0, 0, 0, 0.7)',
    accentText: '#1294d2',
    link: '#4fc3f7',
    star: '#f5b400',
    mutedText: '#7e7e88',
    brandOrange: '#ea5212',
};
